import styled from "styled-components";
import { Link } from "react-router-dom";

export const DivField = styled.div`
  ::-webkit-input-placeholder {
    color: #888888;
    font: normal normal 100 15px Mangueira;
  }
  width: 100%;
  height: 47px;
  border-radius: 10px;
  padding: 0 15px;
  border: 0.5px solid ${(props) => (props.errorCondition ? "red" : "#888888")};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000058;
  display: flex;
  flex-direction: row;
`;

export const Textfield = styled.input`
  ::-webkit-input-placeholder {
    color: #888888;
    font: normal normal normal 16px/21px Roboto;
    letter-spacing: 0px;
  }
  width: 100%;
  height: 47px;
  border-radius: 10px;
  padding: 0 15px;
  border: 0.5px solid ${(props) => (props.errorCondition ? "red" : "#888888")};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000058;
  
`;

export const EyeIcon = styled.span`
  width: 40px;
  line-height: 1.75;
  font-size: 1.5rem;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  justify-self: end;
  user-select: none;
  color: #c9c9c9;
  &:hover {
    transition: 0.5s;
    color: #888888;
  }
`;

export const ErrorMessage = styled.span`
  font: normal normal 600 12px Mangueira;
  color: red;
  margin-top: 10px;
  font-weight: 200;
`;

export const NextButton = styled.button`
  font: normal normal 600 16px/12px Mangueira;
  letter-spacing: 0px;
  text-transform: lowercase;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 45px;
  background-color: #000FFF;
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  margin-top: 16px;
  overflow: hidden;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }

  img {
    float: left;
    padding-left: 0.8rem;
    padding-top: 0.1rem;
    width: 35px;
  }

  span {
    padding-right: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
    padding-top: 5px;
  }
`;

export const ConfirmationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ConfirmationIcon = styled.i`
  font-size: 55px;
  color: #4181f8;
`;

export const Label = styled.label`
  text-align: left;
  font-weight: bold;
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: -5px;
`;

export const RulePasswordContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: start;
  margin-bottom: 10px;
`;

export const RulePassword = styled(Link)`
  color: #000FFF;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: underline;
  font: normal normal normal 14px/21px Mangueira;
  cursor: pointer;
  margin-left: 2px;
`;

export const  ImageInfo = styled.div`
  margin-right: 5px;
  :hover span: {
    visibility: visible;
  }
`;

export const SearchDocumentIcon = styled.div`
  margin-right: 5px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;


export const LoginTitle = styled.span`
  text-align: center;
  letter-spacing: 0px;
  font: normal normal bold 26px/40px Mangueira;
  color: #000000;
  @media (max-width: 768px) {
    text-align: left;
  }
`;
